import React from "react";
import { CopyButton } from "~/components/assistant/CopyButton";

interface DebugFieldProps {
  label: string;
  content: string | object;
  maxHeight?: string;
}

export function DebugField({ label, content, maxHeight = "600px" }: DebugFieldProps) {
  const contentString = typeof content === "string" ? content : JSON.stringify(content, null, 2);

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs font-medium">{label}:</p>
        <CopyButton text={contentString} variant="light" size="sm" />
      </div>
      <pre
        className="text-xs bg-gray-50 text-gray-800 px-3 py-2 rounded whitespace-pre-wrap break-words overflow-y-auto"
        style={{ maxHeight }}
      >
        {contentString}
      </pre>
    </div>
  );
}
